export default __webpack_public_path__ + "i18n/translation-it.02ac1089.json";